import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
/** A MenuCategory component to allow multiple lists in one menu */
const MenuCategory = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    title,
    titleUnderline,
    style = {},
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    ref: ref,
    className: className,
    $_css: [style]
  }, title && /*#__PURE__*/React.createElement(_StyledH, {
    $_css2: [theme.typography.heading4, {
      color: theme.tokens.colors.text.secondary.value,
      margin: "".concat(theme.spacing.M, "px ").concat(theme.spacing.M, "px 0px")
    }, titleUnderline && {
      borderBottom: "1px solid ".concat(theme.tokens.colors.border.subtle.value),
      paddingBottom: 5
    }]
  }, title), children);
});
MenuCategory.displayName = 'MenuCategory';
MenuCategory.propTypes = {
  /** The content to category */
  children: PropTypes.any,
  /* Styles applied to the root element */
  style: stylePropType,
  /* Class applied to the root element */
  className: PropTypes.string,
  /** Category title */
  title: PropTypes.any,
  /** show underline below title */
  titleUnderline: PropTypes.bool
};
export default MenuCategory;
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), p => p.$_css);
var _StyledH = _styled2("h4").withConfig({
  displayName: "MenuCategory___StyledH",
  componentId: "sc-nh2hus-0"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=MenuCategory.js.map